import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moneyFormatter'
})
export class MoneyFormatterPipe implements PipeTransform {

  transform(value: number, useSign: boolean = false, sign?: string): any {
    let val = 0;
    if (value) {
      val = parseFloat(value.toString().replace('$', '').replace(',', ''));
    }
    let outVal = '';

    if (useSign) {
      if (sign) {
        outVal = `${sign}${Number(val.toFixed(2)).toLocaleString('en-US')}`.toString();
      }
      outVal = `$${Number(val.toFixed(2)).toLocaleString('en-US')}`.toString();
    } else {
      outVal = `${Number(val.toFixed(2)).toLocaleString('en-US')}`.toString();
    }

    if (outVal.indexOf('.') == -1) {
      outVal = outVal + '.00';
    } else {
      if (!/(\.\d{2,2})$/.test(outVal)) {
        outVal = outVal + '0';
      }
    }

    if (outVal.indexOf("$-") > -1) {
      outVal = outVal.replace('$-', '($') + ')';
    }

    return outVal;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/money-formatter.pipe.ts